import Vue from 'vue'
import Router from 'vue-router'
import ProcessNav from '@/view/ProcessNav'
import ElectricMachine from '@/view/ElectricMachine/ElectricMachine'
import LoadSelection from '@/view/LoadSelection/LoadSelection.vue'
import ApplicationSelection from '@/view/ApplicationSelection/ApplicationSelection.vue'
import MotorSelection from '@/view/MotorSelection/MotorSelection.vue'
import MomentInertia from '@/view/MomentInertia/MomentInertia'
import FileDownLoad from '@/view/FileDownLoad.vue'
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'ProcessNav',
    component: ProcessNav
  },{
    path: '/electricMachine',
    name: 'ElectricMachine',
    component: ElectricMachine
  },{
    path: '/loadSelection',
    name: 'LoadSelection',
    component: LoadSelection
  },{
    path: '/applicationSelection',
    name: 'ApplicationSelection',
    component: ApplicationSelection
  },{
    path: '/motorSelection',
    name: 'MotorSelection',
    component: MotorSelection
  },{
    path: '/momentInertia',
    name: 'MomentInertia',
    component: MomentInertia
  },{
    path: '/fileDownLoad',
    name: 'FileDownLoad',
    component: FileDownLoad
  }
]
})



// WEBPACK FOOTER //
// ./src/router/index.js